export default __webpack_public_path__ + "static/media/category-cash-back.67ebe853.svg";